import React from 'react';

const MintPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-display font-bold text-primary-900 mb-8">
        <span className="text-accent-wood">Mint</span> Your Legacy
      </h1>
      <div className="bg-white p-8 rounded-xl border border-primary-200 shadow-sm">
        <p className="text-primary-600 mb-4">
          Mint page coming soon...
        </p>
      </div>
    </div>
  );
};

export default MintPage; 